import React from 'react';

export const PlanListSlick =
  require('../../src/front/Businesses/PlanListSlick').default;

const Review = require('../../src/front/Plans/ReviewContainer').default;

export const ReviewContainer = (props) => (
  <Review {...props} titleProps={{ id: 'businessPlanReviewsContainer' }} />
);

export const XsSnsShareButton =
  require('../../src/core/Businesses/components/XsSnsShareButton').default;

export default require('../../src/front/Businesses/Businesses').default;
